import styled from "styled-components"
import theme from "../../../theme"


export const Section = styled.section`
  display: flex;
  flex-direction: column;
  color: ${theme.text.default};
  align-items: center;
  font-size: 1.4rem;  
  background: ${theme.bg.light};
  margin-bottom: 80px;
  max-width: 100%;
  overflow-x: hidden;
  
  @media (min-width: 1024px) {
    flex-direction: ${props => props.reversed ? "row-reverse" : "row"};
  }
  
  @media(min-width: 1240px){
      max-width: 1240px;
  }
`

export const SectionTheme = styled.div`
  & > h1,h2,h3,h4,h5,h6{
    margin: 0;
    padding: 0;
    line-height: 1.2;
    letter-spacing: -.015em;
    color: ${theme.text.alt};
  }
  
 & > h1,h2 {
    font-size: 2rem;
    background-image:linear-gradient(90deg,${theme.brand.default},${theme.brand.alt},${theme.brand.default});
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -.015em;
 }
 
  & > h3 {
    font-size: 2rem;
    font-weight: 600;
 }
 
  & > h4 {
    font-size: 1.8rem;
    line-height: 1.2;
    font-weight: 500;
 }
 
 & > h5 {
    font-size: 1.5rem;
    line-height: 1.2;
    font-weight: 500;
 }
 
  & > h6 {
    font-size: 1.3rem;
    line-height: 1.2;
    font-weight: 500;
 }
 
  & > p, li {
    line-height: 1.47059;
    font-size: 1rem;
    color: ${theme.text.default};
    font-weight: 400;
    letter-spacing: -.022em;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  flex: 0 50%;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  
  @media(min-width: 1240px){
    height: 700px;
  }
`

export const SectionImage = styled.img`
  width: 100%;
  height: auto;
    
  @media (min-width: 1024px) {
    width: auto;
    height: 100%;
  }
`

export const SectionContainer = styled(SectionTheme)`
  flex: 1 50%;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  position:relative;
  height: min-content;
  max-width: 920px;
  justify-content: ${props => props.reversed ? "flex-end" : "flex-end"}; 
  
  @media (min-width: 1024px) {
    padding: 2rem;
  }
`
